export default __webpack_public_path__ + "assets/models/21f18f2f719b9ea12caadee50f1bc7d8.glb";